<template>
	<el-dialog :visible="show" append-to-body width="500px" title="修改场景信息" :close-on-click-modal="false" @close="closeDialog">
		<el-form ref="vForm" label-width="110px" :model="vForm">
			<el-form-item label="场景排序" prop="sort" :rules="{ required: true, message: '场景排序必填' }">
				<el-input v-model="vForm.sort"></el-input>
				<div class="v-form-tips">排序值越小越靠前</div>
			</el-form-item>
			<el-form-item label="场景名称" prop="name" :rules="{ required: true, message: '场景名称必填' }">
				<el-input v-model="vForm.name"></el-input>
			</el-form-item>
      <el-form-item label="场景全景图">
        <div v-loading="loading" class="preview-box">
          <img class="img" :src="preview">
          <div class="mask" @click="select"><i class="icon el-icon-plus"></i></div>
        </div>
      </el-form-item>
			<el-form-item label="描述">
				<el-input v-model="vForm.describe" type="textarea" :rows="6"></el-input>
				<div class="v-form-tips">描述字数建议300字符以内，当前字符数：{{ vForm.describe.length }}</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="closeDialog">关闭</el-button>
			<el-button type="primary" :loading="doSubmitLoading" size="small" @click="doSubmit">确 定</el-button>
		</div>
    <input ref="imageInput" hidden type="file" accept="image/*" />
	</el-dialog>
</template>

<script>
	import {mapState, mapActions} from 'vuex';

	export default {

		props: {
			show: Boolean,
			row: {
				type:Object,
				default:null
			}
		},

		data() {
			return {
				loading:false,
				doSubmitLoading: false,
				vForm: {
					id: '',
					sort: '',
					name: '',
					describe:'',
					materialData:''
				},
        preview:''
			}
		},

		computed: {
			...mapState('tour', ['materialId', 'krp', 'sceneDetail','activeGroupId'])
		},

		created() {
			this.vForm.id = this.row.id;
			this.preview = this.row.thumbPreview;
			this.vForm.sort = this.row.sort;
			this.vForm.name = this.row.name;
			this.vForm.describe = this.row.describe || '';
		},


		methods: {

			...mapActions("tour", {
				actionGetSceneDetail: "getSceneDetail",
				actionGetWorksDetail: "getWorksDetail",
			}),

			closeDialog() {
				this.$emit('update:show', false)
			},

			select() {
				let input = this.$refs.imageInput;
				input.click();
				input.onchange = e => {
					let files = e.target.files;
					this.doUpload(files);
				};
			},

			//上传文件
			async doUpload(files) {
				this.loading = true;
				try {
					let res = await this.utils.upload.uploadFiles(files, {bucket: "vybbasevr"});
					this.vForm.materialData = [{name:res[0].name,image:res[0].key}];
					this.preview = res[0].preview;
				} catch (e) {
					console.error(e);
				}
				this.$refs.imageInput.value = "";
				this.loading = false;
			},

			handleUpload(image){
				this.vForm.materialData = [{name:'',image}]
      },

			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					await this.api.material.editMaterial(Object.assign({groupId:this.sceneDetail.groupId},this.vForm));
					await this.actionGetWorksDetail({worksId: this.$route.query.id,groupId:this.sceneDetail.groupId});
					this.$message.success(`修改成功`);
					this.closeDialog();
				} catch (e) {
					console.error(e);
				}
				this.doSubmitLoading = false;
			},


		}
	}
</script>

<style scoped>
  .preview-box{
    position: relative;
    width: 300px;
    height: 150px;
  }

  .preview-box .img{
    display: block;
    width: 100%;
    height: 100%;
  }

  .preview-box .mask{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    color: #fff;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
    left:0;
    top:0;
    display: none;
  }

  .preview-box:hover .mask{
    display: flex;
  }

</style>

